'use strict';

import { toJson } from 'angular';

export default class CalendarController {
	/*@ngInject*/
	constructor(Modal, Auth, $http, $filter, $uibModal, $compile, $timeout, $scope, copyTextToClipboard, ColorFinder, HourFinder, StartFinder, ValidIndexes, DateFinder) {
		this.Modal = Modal;
		this.getCurrentUser = Auth.getCurrentUserSync;
		this.$http = $http;
		this.$filter = $filter;
		this.$uibModal = $uibModal;
		this.$compile = $compile;
		this.$timeout = $timeout;
		this.$scope = $scope;
		this.copyTextToClipboard = copyTextToClipboard;
		this.ColorFinder = ColorFinder;
		this.HourFinder = HourFinder;
		this.StartFinder = StartFinder;
		this.ValidIndexes = ValidIndexes;
		this.DateFinder = DateFinder;
	}

	$onInit() {
		this.isSandbox = location.host.includes('sandbox') || location.host.includes('8082');
		this.visibleLessons = []; //used by sandbox
		this.locationCache = {};
        this.hasPreloadedLocations = false;
		this.username = this.getCurrentUser().name;
		this.switchDays = 0;

		this.intDay();

		this.icons = {
			first: '',
			second: '',
			third: '',
			fourth: '',
			fifth: '',
			sixth: '',
			year12: '',
			xero: '',
		};

		this.navIcons = ['first', 'second', 'year12', 'xero'];

		this.clearIconFilters();

		this.$http.get('/api/icons').then(response => {
			if(response && response.data && response.data[0]) {
				this.icons = response.data[0];
			}
			this.finishedLoad();
		});

		this.$http.get('/api/termsettings').then(response => {
			if(response && response.data && response.data[0]) {
				this.term = response.data[0];
			}
			this.finishedLoad();
		});

		//defaults to paddington
		this.location = this.username == 'cannonhill' ? 'cannon hill' : 'paddington';
		//setting locations and number of rooms with [0,1,2] arrays to loop through
		//a bit hacky but is OK
		this.rooms = {
			'paddington': this.createArray(7), // from 9 changed to 7
			'cannon hill': this.createArray(6),
			'online': this.createArray(12),
			'mt-gravatt': this.createArray(5),

		};
		//creates segments for the days
		this.segments = this.createArray(48);

		this.selectedDate = this.calendarDate;

		this.loading = true; //defaults to loading

		//hacky code but waits to be 4 to call updateCal()/show loaded screen
		this.loaded = 0;

		this.$http.get('/api/students').then(response => {
			this.students = response.data;
			this.finishedLoad();
		});

		this.$http.get('/api/tutors').then(response => {
			this.tutors = response.data;
			this.finishedLoad();
		});


		var changeColour = (colour) => {
			colour = colour.toLowerCase();
			return ($itemScope, $event) => {
				var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
				var _uid = _targ.dataset.id;
				var _instance = +_targ.dataset.instance;
				this.editColour(_uid, _instance, colour);
			};
		};

		var tempColourChildren = ['Yellow', 'Green', 'Dark Green', 'Orange', 'Purple', 'Red', 'Dark Red'];
		tempColourChildren = tempColourChildren.map(item => {
			return {
				text: item,
				click: changeColour(item)
			};
		});

		var changeIcon = (icon, perm) => {
			return ($itemScope, $event) => {
				var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
				var _uid = _targ.dataset.id;
				var _instance = +_targ.dataset.instance;
				this.editIcon(_uid, _instance, icon, perm);
			};
		};

		var menuDisplayed = ($itemScope, $event) => {
			return !!($event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell'));
		};

		var dateSame = ($itemScope, $event) => {
			var today = new Date();
			var tomorrow = new Date();
			tomorrow.setDate(today.getDate() + 1);
			return menuDisplayed($itemScope, $event) && (this.calendarDate.toDateString() === today.toDateString() || this.calendarDate.toDateString() === tomorrow.toDateString());
		};

		this.menuOptions = [
      //   {
      //     text: "Add Session",
      //     click: ($itemScope, $event) => {
      //       // console.log($itemScope, $event);
      //       var _time =
      //         (1440 / this.segments.length) * $itemScope.$parent.segment;
      //       this.addSessionModal(_time, $itemScope.room);
      //     },
      //   },
      {
        text: "Create Invoice",
        hasBottomDivider: true,
        click: ($itemScope, $event) => {
          const targ = $event.target.classList.contains("session-cell")
            ? $event.target
            : $event.target.closest(".session-cell");
          const uid = targ.dataset.id;
          const instance = +targ.dataset.instance;
          this.createStudentInvoice(uid, instance);
        },
      },
      // {
      // 	text: 'Copy',
      // 	displayed: menuDisplayed,
      // 	children: [
      // 		{
      // 			text: 'Phone Number',
      // 			click: ($itemScope, $event) => {
      // 				var text = $event.target.classList.contains('session-cell') ? $event.target.dataset.phone : $event.target.closest('.session-cell').dataset.phone;
      // 				this.copyTextToClipboard(text);
      // 			},
      // 		},
      // 		{
      // 			text: 'Email Address',
      // 			click: ($itemScope, $event) => {
      // 				var text = $event.target.classList.contains('session-cell') ? $event.target.dataset.email : $event.target.closest('.session-cell').dataset.email;
      // 				this.copyTextToClipboard(text);
      // 			},
      // 		},
      // 	]
      // },
      //   {
      //     text: "Delete",
      //     hasBottomDivider: true,
      //     displayed: menuDisplayed,
      //     children: [
      //       {
      //         text: "Instance",
      //         click: ($itemScope, $event) => {
      //           var _targ = $event.target.classList.contains("session-cell")
      //             ? $event.target
      //             : $event.target.closest(".session-cell");
      //           var _uid = _targ.dataset.id;
      //           var _instance = +_targ.dataset.instance;
      //           this.overwriteHide(_uid, _instance);
      //         },
      //       },
      //       {
      //         text: "Series",
      //         click: ($itemScope, $event) => {
      //           var _targ = $event.target.classList.contains("session-cell")
      //             ? $event.target
      //             : $event.target.closest(".session-cell");
      //           var _uid = _targ.dataset.id;
      //           if (
      //             confirm(
      //               "Are you sure you want to permanently delete this series?",
      //             )
      //           ) {
      //             this.deleteSeries(_uid);
      //           }
      //         },
      //       },
      //     ],
      //   },
      {
        text: "Student",
        displayed: menuDisplayed,
        children: [
          {
            text: "SMS Student",
            click: ($itemScope, $event) => {
              var _targ = $event.target.classList.contains("session-cell")
                ? $event.target
                : $event.target.closest(".session-cell");
              var _uid = _targ.dataset.id;
              var _instance = +_targ.dataset.instance;
              var _time = $itemScope.$parent.segment;
              this.sendSMS(_uid, _instance, _time, false);
            },
          },
          {
            text: "Email Term Schedule",
            click: ($itemScope, $event) => {
              const targ = $event.target.classList.contains("session-cell")
                ? $event.target
                : $event.target.closest(".session-cell");
              const uid = targ.dataset.id;
              this.sendEmailScheduleNotif(uid);
            },
          },
          {
            text: "Copy Phone",
            click: ($itemScope, $event) => {
              var text = $event.target.classList.contains("session-cell")
                ? $event.target.dataset.phone
                : $event.target.closest(".session-cell").dataset.phone;
              this.copyTextToClipboard(text);
            },
          },
          {
            text: "Copy Email",
            click: ($itemScope, $event) => {
              var text = $event.target.classList.contains("session-cell")
                ? $event.target.dataset.email
                : $event.target.closest(".session-cell").dataset.email;
              this.copyTextToClipboard(text);
            },
          },
        ],
      },
      // {
      // 	text: 'SMS Student',
      // 	displayed: menuDisplayed,
      // 	click: ($itemScope, $event) => {
      // 		var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
      // 		var _uid = _targ.dataset.id;
      // 		var _instance = +_targ.dataset.instance;
      // 		var _time = $itemScope.$parent.segment;
      // 		this.sendSMS(_uid, _instance, _time, false);
      // 	}
      // },
      {
        text: "Tutor",
        hasBottomDivider: true,
        displayed: menuDisplayed,
        children: [
          {
            text: "SMS Tutor",
            click: ($itemScope, $event) => {
              var _targ = $event.target.classList.contains("session-cell")
                ? $event.target
                : $event.target.closest(".session-cell");
              var _uid = _targ.dataset.id;
              var _instance = +_targ.dataset.instance;
              var _time = $itemScope.$parent.segment;
              this.sendSMS(_uid, _instance, _time, true);
            },
          },
          {
            text: "Email Tutor",
            children: [
              {
                text: "This Day",
                click: ($itemScope, $event) => {
                  const targ = $event.target.classList.contains("session-cell")
                    ? $event.target
                    : $event.target.closest(".session-cell");
                  const uid = targ.dataset.id;
                  this.sendEmail(uid, this.calendarDate, false, false);
                },
              },
              {
                text: "This Day - With Subjects",
                click: ($itemScope, $event) => {
                  const targ = $event.target.classList.contains("session-cell")
                    ? $event.target
                    : $event.target.closest(".session-cell");
                  const uid = targ.dataset.id;
                  this.sendEmail(uid, this.calendarDate, false, true);
                },
              },
              {
                text: "This Week",
                click: ($itemScope, $event) => {
                  const targ = $event.target.classList.contains("session-cell")
                    ? $event.target
                    : $event.target.closest(".session-cell");
                  const uid = targ.dataset.id;
                  this.sendEmail(uid, this.calendarDate, true, false);
                },
              },
              {
                text: "This Week - With Subjects",
                click: ($itemScope, $event) => {
                  const targ = $event.target.classList.contains("session-cell")
                    ? $event.target
                    : $event.target.closest(".session-cell");
                  const uid = targ.dataset.id;
                  this.sendEmail(uid, this.calendarDate, true, true);
                },
              },
            ],
          },
          {
            text: "Copy Phone",
            click: ($itemScope, $event) => {
              var text = $event.target.classList.contains("session-cell")
                ? $event.target.dataset.tutorPhone
                : $event.target.closest(".session-cell").dataset.tutorPhone;
              navigator.clipboard.writeText(text);
            },
          },
          {
            text: "Copy Email",
            click: ($itemScope, $event) => {
              var text = $event.target.classList.contains("session-cell")
                ? $event.target.dataset.tutorEmail
                : $event.target.closest(".session-cell").dataset.tutorEmail;
              navigator.clipboard.writeText(text);
            },
          },
        ],
      },
      {
        text: "Session",
        displayed: menuDisplayed,
        children: [
          {
            text: "Create Session",
            click: ($itemScope, $event) => {
              // console.log($itemScope, $event);
              var _time =
                (1440 / this.segments.length) * $itemScope.$parent.segment;
              this.addSessionModal(_time, $itemScope.room);
            },
          },
          {
            text: "Delete Instance",
            click: ($itemScope, $event) => {
              var _targ = $event.target.classList.contains("session-cell")
                ? $event.target
                : $event.target.closest(".session-cell");
              var _uid = _targ.dataset.id;
              var _instance = +_targ.dataset.instance;
              this.overwriteHide(_uid, _instance);
            },
          },
          {
            text: "Delete Series",
            click: ($itemScope, $event) => {
              var _targ = $event.target.classList.contains("session-cell")
                ? $event.target
                : $event.target.closest(".session-cell");
              var _uid = _targ.dataset.id;
              if (
                confirm(
                  "Are you sure you want to permanently delete this series?",
                )
              ) {
                this.deleteSeries(_uid);
              }
            },
          },
          {
            text: "Temporary Icon",
            displayed: menuDisplayed,
            children: [
              {
                text: "New Client",
                click: changeIcon(2, false),
              },
			  {
                text: "Paid",
                click: changeIcon(1, false),
              },
              {
                text: "Ignore Invoice",
                click: changeIcon(12, false),
              },
              {
                text: "Tick",
                click: changeIcon(5, false),
              },
              {
                text: "Cross",
                click: changeIcon(6, false),
              },
              {
                text: "Variable",
                click: changeIcon(7, false),
              },
            ],
          },
          {
            text: "Permanent Icon",
            hasBottomDivider: true,
            children: [
              {
                text: "Credit Card Stored",
                click: changeIcon(9, true),
              },
              {
                text: "Credit Card Online",
                click: changeIcon(11, true),
              },
              {
                text: "Direct Debit",
                click: changeIcon(8, true),
              },
              {
                text: "EFTPOS",
                click: changeIcon(10, true),
              },
              {
                text: "Pay Upfront",
                click: changeIcon(7, true),
              },
              {
                text: "Invoice Variation",
                click: changeIcon(3, true),
              },
            ],
          },
          {
            text: "Toggle Changeover Start",
            click: ($itemScope, $event) => {
              var _targ = $event.target.classList.contains("session-cell")
                ? $event.target
                : $event.target.closest(".session-cell");
              var _uid = _targ.dataset.id;
              var _instance = +_targ.dataset.instance;
              this.overwriteChangeoverStart(_uid, _instance);
            },
          },
          {
            text: "Toggle Changeover End",
            click: ($itemScope, $event) => {
              var _targ = $event.target.classList.contains("session-cell")
                ? $event.target
                : $event.target.closest(".session-cell");
              var _uid = _targ.dataset.id;
              var _instance = +_targ.dataset.instance;
              this.overwriteChangeover(_uid, _instance);
            },
          },
        ],
      },
      // {
      // 	text: 'SMS Tutor',
      // 	hasBottomDivider: true,
      // 	displayed: menuDisplayed,
      // 	click: ($itemScope, $event) => {
      // 		var _targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
      // 		var _uid = _targ.dataset.id;
      // 		var _instance = +_targ.dataset.instance;
      // 		var _time = $itemScope.$parent.segment;
      // 		this.sendSMS(_uid, _instance, _time, true);
      // 	}
      // },
      //   {
      //     text: "Email Tutor",
      //     children: [
      //       {
      //         text: "This Day",
      //         click: ($itemScope, $event) => {
      //           const targ = $event.target.classList.contains("session-cell")
      //             ? $event.target
      //             : $event.target.closest(".session-cell");
      //           const uid = targ.dataset.id;
      //           this.sendEmail(uid, this.calendarDate, false, false);
      //         },
      //       },
      //       {
      //         text: "This Day - With Subjects",
      //         click: ($itemScope, $event) => {
      //           const targ = $event.target.classList.contains("session-cell")
      //             ? $event.target
      //             : $event.target.closest(".session-cell");
      //           const uid = targ.dataset.id;
      //           this.sendEmail(uid, this.calendarDate, false, true);
      //         },
      //       },
      //       {
      //         text: "This Week",
      //         click: ($itemScope, $event) => {
      //           const targ = $event.target.classList.contains("session-cell")
      //             ? $event.target
      //             : $event.target.closest(".session-cell");
      //           const uid = targ.dataset.id;
      //           this.sendEmail(uid, this.calendarDate, true, false);
      //         },
      //       },
      //       {
      //         text: "This Week - With Subjects",
      //         click: ($itemScope, $event) => {
      //           const targ = $event.target.classList.contains("session-cell")
      //             ? $event.target
      //             : $event.target.closest(".session-cell");
      //           const uid = targ.dataset.id;
      //           this.sendEmail(uid, this.calendarDate, true, true);
      //         },
      //       },
      //     ],
      //   },
      // {
      //   text: 'Email Student Schedule',
      //   hasBottomDivider: true,
      //   click: ($itemScope, $event) => {
      // 	const targ = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
      // 	const uid = targ.dataset.id;
      // 	this.sendEmailScheduleNotif(uid);
      //   },
      // },
      //   {
      //     text: "Temporary Icon",
      //     displayed: menuDisplayed,
      //     children: [
      //       {
      //         text: "Paid",
      //         click: changeIcon(1, false),
      //       },
      //       {
      //         text: "New Client",
      //         click: changeIcon(2, false),
      //       },
      //       {
      //         text: "Ignore Xero",
      //         click: changeIcon(12, false),
      //       },
      //       {
      //         text: "Tick",
      //         click: changeIcon(5, false),
      //       },
      //       {
      //         text: "Cross",
      //         click: changeIcon(6, false),
      //       },
      //       {
      //         text: "Unknown",
      //         click: changeIcon(7, false),
      //       },
      //     ],
      //   },
      //   {
      //     text: "Permanent Icon",
      //     displayed: menuDisplayed,
      //     hasBottomDivider: true,
      //     children: [
      //       {
      //         text: "Credit Card Stored",
      //         click: changeIcon(9, true),
      //       },
      //       {
      //         text: "Credit Card Online",
      //         click: changeIcon(11, true),
      //       },
      //       {
      //         text: "Direct Debit",
      //         click: changeIcon(8, true),
      //       },
      //       {
      //         text: "EFTPOS",
      //         click: changeIcon(10, true),
      //       },
      //       {
      //         text: "Pay Upfront",
      //         click: changeIcon(7, true),
      //       },
      //       {
      //         text: "Different Pay Rates",
      //         click: changeIcon(3, true),
      //       },
      //     ],
      //   },
      //   {
      //     text: "Toggle Changeover Start",
      //     displayed: menuDisplayed,
      //     click: ($itemScope, $event) => {
      //       var _targ = $event.target.classList.contains("session-cell")
      //         ? $event.target
      //         : $event.target.closest(".session-cell");
      //       var _uid = _targ.dataset.id;
      //       var _instance = +_targ.dataset.instance;
      //       this.overwriteChangeoverStart(_uid, _instance);
      //     },
      //   },
      //   {
      //     text: "Toggle Changeover End",
      //     hasBottomDivider: true,
      //     displayed: menuDisplayed,
      //     click: ($itemScope, $event) => {
      //       var _targ = $event.target.classList.contains("session-cell")
      //         ? $event.target
      //         : $event.target.closest(".session-cell");
      //       var _uid = _targ.dataset.id;
      //       var _instance = +_targ.dataset.instance;
      //       this.overwriteChangeover(_uid, _instance);
      //     },
      //   },
      {
        text: "Close",
      },
    ];
	}

	intDay() {
		//int date
		const today = new Date();
		//remove hours, seconds etc
		this.calendarDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
	}

	invalidateLocationCache(location) {
    Object.keys(this.locationCache).forEach(key => {

        if(key.startsWith(location + '-')) {
            delete this.locationCache[key];
        }

    });
}

	editColour(id, instance, colour) {
		var session = this.sessions.find(session => id == session._id);

		session.overwriteColor = session.overwriteColor || {};
		session.overwriteColor[instance] = colour;
		
		this.$http.put('/api/lessons/' + id, {
			overwriteColor: session.overwriteColor
		}).then(() => {
			this.invalidateLocationCache(this.location);
			this.clearCal();
		});
	}

	clearMessages() {
		this.tempSuccess = null;
	}

	showSuccess() {
		this.tempSuccess = true;
		this.$timeout(() => {
			this.tempSuccess = null;
		}, 3000);
	}

	studentInactive(id, instance) {
		//function makes student inactive
		var session = this.sessions.find(session => id == session._id);

		this.$http.put('/api/students/' + session.student._id, {
			isActive: false
		}).then(() => {
			this.invalidateLocationCache(this.location);
			this.clearCal();
		});
	}

	// Get last and next 3 months
	setSearchTime(calendarDate) {
		this.monthLists = {};
		for(var i = 0; i <= 6; i++) {
			var localeToday = new Date();
			localeToday.setMonth(calendarDate.getMonth() + 3 - i);
			localeToday = localeToday.toLocaleDateString('en-GB', {year: 'numeric', month: '2-digit', day: '2-digit' });
			var month = localeToday.split('/')[1];
			var year = localeToday.split('/')[2];
			if(!(year in this.monthLists)) {
				this.monthLists[year] = [];
			}
			this.monthLists[year].push(month);
		}
	}

	addTermSchedule() {
		var startTerm = new Date(parseInt(this.term.startDate));
		var endTerm = new Date(parseInt(this.term.endDate));
		this.termDays = (this.term.endDate - this.term.startDate) / (1000 * 3600 * 24);
		var dates = this.dateRange(startTerm.toLocaleDateString('en-GB', {year: 'numeric', month: '2-digit', day: '2-digit' }), endTerm.toLocaleDateString('en-GB', {year: 'numeric', month: '2-digit', day: '2-digit' }));
		dates.forEach(date => {
			var year = date.split('/')[0];
			var month = date.split('/')[1];
			if(!this.monthLists[year]) {
				this.monthLists[year] = [];
			}
			if(!this.monthLists[year].includes(month)) {
				this.monthLists[year].push(month);
			}
		});
	}

	clearIconFilters() {
		this.iconFilters = {
			first: false,
			second: false,
			third: false,
			fourth: false,
			fifth: false,
			sixth: false,
			year12: false,
			xero: false,
		};
	}

	sendEmail(id, date, isWeek, withSubjects) {
		if(isWeek) {
			if(date.getDay() === 0) {
				var startOfWeek = date.getDate() - 7;
			} else {
				var startOfWeek = date.getDate() - (date.getDay() - 1);
			}
			var start = new Date(date.getFullYear(), date.getMonth(), startOfWeek);
			var end = new Date(date.getFullYear(), date.getMonth(), startOfWeek + 6);
		} else {
			var start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
			var end = start;
		}

		const tutorID = this.sessions.find(session => id == session._id).tutorUID;
		const tutor = this.tutors.find(tutor => tutorID === tutor._id);
		const tutorSessions = this.sessions.filter(session => tutorID === session.tutorUID).filter(session => session.date);

		var sessionData = [];

		tutorSessions.forEach(session => {
			const validIndexes = this.ValidIndexes(session, start, end);

			validIndexes.forEach(index => {
				const basicTime = this.StartFinder(session, index);
				const formattedTime = this.$filter('minuteConvert')(basicTime, false);
				const sessionDate = this.DateFinder(session, index);
				const formattedDate = this.$filter('toDateString')(sessionDate);
				const color = this.ColorFinder(session, index);

				sessionData.push({
					studentName: session.student.firstName + ' ' + session.student.lastName,
					isTertiary: session.student.isTertiary,
					grade: session.student.grade,
					subjects: session.student.subjects,
					time: formattedTime,
					isEmpty: false,
					basicTime,
					date: formattedDate,
					sessionDate,
					color,
				});
			});
		});

		if(!isWeek) {
			sessionData = sessionData.filter(session => {
				var acceptedColors = ['blue', 'dark blue', 'green', 'dark green', 'purple', 'dark purple', 'lime', 'dark lime', 'orange', 'dark orange'];
				var color = session.color.toLowerCase();
				return acceptedColors.includes(color);
			});
		}

		if(sessionData.length === 0) {
			return alert('Something went wrong. No sessions found.');
		}

		var datesPresent = [];
		sessionData.forEach(session => {
			if(datesPresent.includes(session.date) === false) {
				datesPresent.push(session.date);
			}
		});

		var times = [930, 990, 1050, 1110, 1170, 1230, 1290];

		datesPresent.forEach(datePresent => {
			var filteredSessions = sessionData.filter(session => session.date === datePresent);

			times.forEach(time => {
				const found = filteredSessions.find(session => session.basicTime === time);

				if(!found) {
					const formattedTime = this.$filter('minuteConvert')(time, false);
					const sessionDate = this.$filter('reparseDate')(datePresent);

					sessionData.push({
						basicTime: time,
						isEmpty: true,
						date: datePresent,
						time: formattedTime,
						sessionDate,
					});
				}
			});
		});

		sessionData = sessionData.sort((a, b) => {
			if(a.sessionDate < b.sessionDate) {
				return -1;
			}

			if(a.sessionDate > b.sessionDate) {
				return 1;
			}

			if(a.basicTime < b.basicTime) {
				return -1;
			}

			if(a.basicTime > b.basicTime) {
				return 1;
			}

			return 0;
		}).filter(session => !session.isEmpty);

		var dates = new Set(sessionData.map(session => session.sessionDate));

		var tutorWeek = [];

		dates.forEach(date => {
			var sessionsOnDay = sessionData.filter(session => session.sessionDate == date);
			var thisDate = (new Date(date)).toLocaleDateString('en-AU', { weekday: 'long' });
			// console.log(sessionsOnDay);
			tutorWeek.push({
				[thisDate]: sessionsOnDay
			});
		});


		var schedule = '<ul>';

		tutorWeek.forEach(day => {
			for(const [key, value] of Object.entries(day)) {
				if(isWeek) {
					if(key == 'Saturday' || key == 'Sunday') {
						schedule += `\t<li>${key}<ul>`;
					} else {
						schedule += `\t<li><b>${key}</b><ul>`;
					}
				}
				value.forEach(studentSession => {
					if(studentSession.isTertiary) {
						var grade = '(Uni Student)';
					} else {
						var grade = `(Year ${studentSession.grade})`;
					}

					if(withSubjects && studentSession.subjects) {
						var subjects = ` - ${studentSession.subjects}`;
					} else {
						var subjects = '';
					}

					schedule += `<li>${studentSession.time} - ${studentSession.studentName} ${grade}${subjects}</li>\n`;
				});
				if(isWeek) {
					schedule += `</ul></li>\n`;
				}
			}
		});

		schedule += '</ul>';
		var day = isWeek ? undefined : this.dayOfWeekAsInteger(date.getDay());
		var month = ('0' + (start.getMonth() + 1)).slice(-2);
		var date = ('0' + start.getDate()).slice(-2);
		var subjectDate = date + '/' + month;

		this.$http.post('/api/tutors/send-email/day', {
			content: schedule,
			subject: isWeek ? `Tuition Schedule for Term  ${this.term.termNo} (IMPORTANT)` : `Tuition Schedule for ${day} (${subjectDate})`,
			range: isWeek ? `Week Commencing (${subjectDate})` : `DAY (${subjectDate})`,
			tutorFirstName: tutor.firstName,
			emailAddress: tutor.email,
			termNo: this.term.termNo,
			subjectDate,
			day,
		});
	}

	dayOfWeekAsInteger(day) {
		return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][day];
	}

	createStudentInvoice(id, instance) {
		var perm_exist = [];
		var price_unset = [];
		var foundSessions = [];
		var uniqueSessions = {}; // store sessions of students in the same family
		if(id) {
			var session = this.sessions.find(session => id == session._id);
			session._instance = instance;
			foundSessions.push(session);
		} else {
			foundSessions = this.todaysSessions();
			foundSessions = foundSessions.filter(session => {
				var instance = session._instance;
				if(session.overwriteVisibility && session.overwriteVisibility[instance]) {
					return;
				}
				var acceptedColors = ['blue', 'dark blue', 'green', 'dark green', 'purple', 'dark purple', 'orange', 'dark orange', 'lime', 'dark lime'];
				var color = this.ColorFinder(session, instance).toLowerCase();
				if(color.overwriteColor) {
					var overwriteColor = session.overwriteColor[0].toLowerCase();
					return acceptedColors.includes(color) || acceptedColors.includes(overwriteColor);
				} else {
					return acceptedColors.includes(color);
				}
			});
		}

		foundSessions = foundSessions.map(session => {
			// Filter session with "Xero ignore" for this specific instance
			if(session && !(session.overwriteVar12 && session.overwriteVar12[session._instance])) {
				if(session.student.var7 === true) {
					session.perm_icon = 'DELETE';
				} else if(session.student.var8 === true) {
					session.perm_icon = 'DD';
				} else if(session.student.var9 === true) {
					session.perm_icon = 'CW';
				} else if(session.student.var10 === true) {
					session.perm_icon = '';
				} else if(session.student.var11 === true) {
					session.perm_icon = 'CO';
				} else {
					perm_exist.push(`${session.student.clientFirstName} ${session.student.clientLastName}`);
				}
				if(session.student.price === undefined) {
					price_unset.push(`${session.student.clientFirstName} ${session.student.clientLastName}`);
				}
				session.student.crmID = session.student.crmID.split('-')[0];
				session.referenceNum = session.student.var10 ? `CE${session.student.crmID}` : `CE${session.student.crmID}-${session.perm_icon}`;
				if(session.student.var3 == true) {
					session.referenceNum += '-CHECK';
				}
				session.hours = session.duration / 60;
				if(session.overwriteDuration) {
					if(session.overwriteDuration[session._instance]) {
						session.hours = session.overwriteDuration[session._instance] / 60;
					}
				}
				return session;
			}
		});

		foundSessions.forEach(session => {
			if(session) {
				let id = session.student.crmID;
				if(!uniqueSessions[id]) {
					uniqueSessions[id] = [session];
				} else {
					uniqueSessions[id].push(session);
				}
			}
		});

		if(perm_exist.length > 0) {
			alert(`The permanent icons of students: ${perm_exist.join(', ')} are not set`);
		} else if(price_unset.length > 0) {
			alert(`The prices of students: ${price_unset.join(', ')} are not set`);
		} else {
			this.$http.post('/api/xero/create-invoice', {studentInfo: uniqueSessions, date: this.calendarDate.toISOString()})
				.then(response => {
					if(response.data) {
						alert(`Creating ${response.data.numInvoice} invoices successfully`);
					} else {
						alert('Errors in creating invoices. Please refresh the Xero tokens');
					}
				});
		}
	}

	sendEmailScheduleNotif(id) {
		var studentInfo = this.getStudentInfo(id);
		this.$http.post('/api/students/send-email-notif', {
		  subject: `Tuition Schedule to Finish Term ${this.term.termNo}`,
		  studentInfo: [studentInfo],
		  email: studentInfo.clientEmailAddress,
		});
	}

  	getStudentInfo(id) {
		var start = new Date(parseInt(this.term.startDate));
		var end = new Date(parseInt(this.term.endDate));
		var termNo = this.term.termNo;
		var sixthSunday = this.term.sixthSunday;

		var weekEnderResults = [];
		var day = 0;
		var current = new Date(start);

		current.setDate(current.getDate() + (day - current.getDay() + 7) % 7);
		end.setDate(end.getDate() + ((7 - end.getDay()) % 7));

		while(current <= end) {
			var weekEnder = new Date(+current);
			weekEnderResults.push({
				value: weekEnder,
				duration: 0
			});
			current.setDate(current.getDate() + 7);
		}
		var studentId = this.sessions.find(session => id === session._id).clientUID;
		var student = this.sessions.find(session => id === session._id).student;


		var sessionData = [];
		var sessions = this.sessions.filter(session => session.clientUID === studentId);

		sessions.forEach(session => {
			const validIndexes = this.ValidIndexes(session, start, end);

			var specificNotes = '';
			if(session.overwriteNotes) {
				Object.values(session.overwriteNotes).forEach(val => {
					if(val) {
						specificNotes += ('\n' + val);
					}
				});
			}

			validIndexes.forEach(index => {
				const sessionDate = this.DateFinder(session, index);
				const formattedDate = this.$filter('toDateString')(sessionDate);
				const parsedDate = this.$filter('reparseDate')(formattedDate);
				const color = this.ColorFinder(session, index);

				sessionData.push({
					duration: session.duration,
					overwriteDuration: session.overwriteDuration,
					sessionDate,
					date: parsedDate,
					globalNotes: session.globalNotes,
					specificNotes,
					color,
					location: session.location,
					tutorName: session.tutor ? session.tutor.fullName : '',
				});
			});
		});

		sessionData = sessionData.filter(session => {
			var acceptedColors = ['blue', 'dark blue', 'green', 'dark green', 'purple', 'dark purple', 'orange', 'dark orange', 'lime', 'dark lime'];
			var color = session.color.toLowerCase();
			if(color.overwriteColor) {
				var overwriteColor = session.overwriteColor[0].toLowerCase();
				return acceptedColors.includes(color) || acceptedColors.includes(overwriteColor);
			} else {
				return acceptedColors.includes(color);
			}
		});

		sessionData = sessionData.sort((a, b) => {
			if(a.sessionDate < b.sessionDate) {
				return -1;
			}

			if(a.sessionDate > b.sessionDate) {
				return 1;
			}

			if(a.basicTime < b.basicTime) {
				return -1;
			}

			if(a.basicTime > b.basicTime) {
				return 1;
			}
			return 0;
		});

		var hoursCompleted = 0;
		var weekList = [];

		weekEnderResults.forEach((weekend, i, weekends) => {
			var weekendDate = new Date(weekend.value);
			var setNotes = new Set();
			sessionData.forEach(session => {
				weekend.tutorName = session.tutorName;
				weekend.location = session.location;
				if(session.globalNotes) {
					setNotes.add(session.globalNotes);
				}
				weekend.specificNotes = session.specificNotes;
				var duration = session.duration / 60;
				if(typeof session.overwriteDuration === 'object') {
					var index = (i + 1).toString();
					if(session.overwriteDuration.hasOwnProperty(index)) {
						duration = session.overwriteDuration[index] / 60;
					}
				}
				let sessionDate = new Date(session.date);
				if(i === 0 && sessionDate <= weekendDate) {
					weekend.duration += duration;
				} else if(i > 0) {
					var weekendStart = new Date(weekends[i - 1].value);
					if(sessionDate > weekendStart && sessionDate <= weekendDate) {
						weekend.duration += duration;
					}
				}
			});


			var month = ('0' + (weekendDate.getMonth() + 1)).slice(-2);
			var date = ('0' + weekendDate.getDate()).slice(-2);
			var year = weekendDate.getFullYear();

			var status = i > 4 ? 'Scheduled' : 'Completed';
			var toBeRescheduled = false;
			if(i >= 0 && i <= 4) {
				hoursCompleted += weekend.duration;
				if(weekend.duration == 0) {
					status += ' (To Be Rescheduled)';
					toBeRescheduled = true;
				}
			} else if(i === 9) {
				status += '  (Does This Session Need To Be Rescheduled?)';
			}

			weekList.push({
				location: weekend.location,
				tutorName: weekend.tutorName,
				globalNotes: Array.from(setNotes),
				specificNotes: weekend.specificNotes,
				duration: weekend.duration,
				date: date + '/' + month + '/' + year,
				value:	`Week Ending ${date}/${month} - ${weekend.duration} Hour ${status}`,
				toBeRescheduled,
			});
		});

		var studentInfo = {
			clientEmailAddress: student.clientEmail ? student.clientEmail : '',
			clientName: student.clientFirstName,
			clientLastName: student.clientLastName,
			studentName: student.firstName,
			mobileNumber: student.clientPh,
			termNo,
			sixthSunday,
			hoursCompleted,
			hoursToFinish: 10 - hoursCompleted,
			weekList,
		};

		return studentInfo;
  	}

	sendSMS(id, instance, time, isTutor) {
		var session = this.sessions.find(session => id === session._id);
		var tutor = session.tutor;
		var student = session.student;

		var today = new Date();
		var tomorrow = new Date();
		tomorrow.setDate(today.getDate() + 1);
		var isTomorrow = this.calendarDate.toDateString() === tomorrow.toDateString();

		this.sendSMSModal(student, time, tutor, isTutor, isTomorrow);
	}

	colourCountModal() {
		const todaysSessions = this.todaysSessions();
		const calendarDate = this.calendarDate;

		this.$uibModal.open({
			template: require('./colour-count/colour-count.html'),
			controller: 'ColourCountController',
			controllerAs: 'vm',
			resolve: {
				todaysSessions: () => {
					return todaysSessions;
				},
				calendarDate: () => {
					return calendarDate;
				},
			}
		});
	}

	sendSMSModal(student, time, tutor, isTutor, isTomorrow) {
		this.$uibModal.open({
			template: require('./send-sms/send-sms.html'),
			controller: 'SendSMSController',
			controllerAs: 'vm',
			resolve: {
				data: () => {
					return {
						student,
						time,
						tutor,
						isTutor,
						isTomorrow,
					};
				}
			}
		}).result.then(() => {
			this.showSuccess();
		});
	}

	editIcon(id, instance, icon, perm) {
		var session = this.sessions.find(session => id === session._id);

		if(perm) {
			//needs to be either 3 or 4 here
			var key = 'var' + String(icon);
			var property = !session.student[key];
			var change = { [key]: property };

			this.$http.put('/api/students/' + session.student._id, change).then(() => {
				const student = this.students.find(s => s._id === session.student._id);
				student[key] = property;
				this.invalidateLocationCache(this.location);
				this.clearCal();
			});

			return;
		}

		//can be 1,2,5,6
		var key = 'overwriteVar' + String(icon);
		session[key] = session[key] || {};
		session[key][instance] = !session[key][instance];
		var change = { [key]: session[key] };

		this.$http.put(`/api/lessons/${id}`, change).then(() => {		
			this.invalidateLocationCache(this.location);
			this.clearCal();
		});
	}

	deleteSeries(id) {
		const index = this.sessions.findIndex(s => s._id === id);
		this.sessions = [...this.sessions.slice(0, index), ...this.sessions.slice(index + 1)];
		this.$http.delete('/api/lessons/' + id)
			.then(() => {
				console.log('Session deleted:', id);
				this.invalidateLocationCache(this.location);
				this.clearCal();
			});
	}

	overwriteHide(id, instance) {
		this.sessions.forEach(session => {
			if(id === session._id) {
				session.overwriteVisibility = session.overwriteVisibility || {};
				session.overwriteVisibility[instance] = true;
				this.$http.put('/api/lessons/' + id, {
					overwriteVisibility: session.overwriteVisibility
				}).then(() => {
					this.invalidateLocationCache(this.location);
					this.clearCal();
				});
			}
		});
	}

	overwriteChangeover(id, instance) {
		this.sessions.forEach(session => {
			if(id === session._id) {
				session.overwriteChangeover = session.overwriteChangeover || {};
				if(typeof session.overwriteChangeover[instance] === 'undefined') {
					session.overwriteChangeover[instance] = true;
				} else {
					session.overwriteChangeover[instance] = !session.overwriteChangeover[instance];
				}

				this.$http.put('/api/lessons/' + id, {
					overwriteChangeover: session.overwriteChangeover
				}).then(() => {
					this.invalidateLocationCache(this.location);
					this.clearCal();
				});
			}
		});
	}

	overwriteChangeoverStart(id, instance) {
		this.sessions.forEach(session => {
			if(id === session._id) {
				session.overwriteChangeoverStart = session.overwriteChangeoverStart || {};
				if(typeof session.overwriteChangeoverStart[instance] === 'undefined') {
					session.overwriteChangeoverStart[instance] = true;
				} else {
					session.overwriteChangeoverStart[instance] = !session.overwriteChangeoverStart[instance];
				}

				this.$http.put('/api/lessons/' + id, {
					overwriteChangeoverStart: session.overwriteChangeoverStart
				}).then(() => {
					this.invalidateLocationCache(this.location);
					this.clearCal();
				});
			}
		});
	}

	iconFilterChange(key) {
		this.iconFilters[key] = !this.iconFilters[key];
		this.clearCal();
	}

	finishedLoad() {
		this.loaded++;
		if(this.loaded === 4) {
			this.updateCal();
		}
	}

	todaysSessions() {
		var parsedDate = this.$filter('date')(this.calendarDate, 'dd/MM/yyyy');
		var cleanDate = this.$filter('reparseDate')(parsedDate);
		var sessions = this.sessions;

		//filter via icons
		sessions = sessions.filter(session => {
			if(!session.date) {
				// console.log(session)
				return;
			}

			var objSession = this.$filter('reparseDate')(session.date);
			var daysAhead = Math.round((cleanDate - objSession) / 86400000);
			var instance = daysAhead / session.frequency;

			if(this.iconFilters.first && (!session.overwriteVar1 || session.overwriteVar1[instance] !== true)) {
				return;
			}

			if(this.iconFilters.second && (!session.overwriteVar2 || session.overwriteVar2[instance] !== true)) {
				return;
			}

			if(this.iconFilters.third && session.student.var3 !== true) {
				return;
			}

			if(this.iconFilters.fourth && session.student.var4 !== true) {
				return;
			}

			if(this.iconFilters.fifth && (!session.overwriteVar5 || session.overwriteVar5[instance] !== true)) {
				return;
			}

			if(this.iconFilters.sixth && (!session.overwriteVar6 || session.overwriteVar6[instance] !== true)) {
				return;
			}

			if(this.iconFilters.xero && (!session.overwriteVar12 || session.overwriteVar12[instance] !== true)) {
				return;
			}

			if(this.iconFilters.year12 && session.student.grade !== 12) {
				return;
			}
			return true;
		});

		sessions = sessions.map(session => {
			if(!session.student && session.clientUID) {
				session.student = this.students.find(s => s._id === session.clientUID);
			}

			if(!session.tutor && session.tutorUID) {
				session.tutor = this.tutors.find(t => t._id === session.tutorUID);
			}
			return session;
		});

		if(this.searchFilter)
			sessions = this.$filter('filter')(this.sessions, this.searchFilter);

		var filteredSessions = sessions.filter(session => {
			if(session.isHidden)
				return;

			if(session.location != this.location)
				return; //wrong location

			if(session.date == parsedDate)
				return true;

			if(session.instances == 1)
				return; //gets rid of one-off events
			//bc if they're a one-off and they don't fall
			//on same day then they need to be returned

			var objSession = this.$filter('reparseDate')(session.date);

			if(objSession > cleanDate)
				return; //first session is after cal date

			var daysAhead = Math.round((cleanDate.getTime() - objSession.getTime()) / 86400000);

			if(daysAhead % session.frequency !== 0)
				return; //if mod returns > 0 then it must be a dif day

			var _instance = daysAhead / session.frequency; //returns supposed instance
			//remember that it's still zero-indexed here too

			if(session.instances === 0) //if infinite
				return true;

			if(session.instances > _instance) //if more or equal instances possible
				return true;
		});

		return filteredSessions.map(session => {
			if(session.date == parsedDate) {
				session._instance = 0;
				return session;
			}

			var objSession = this.$filter('reparseDate')(session.date);
			var daysAhead = Math.round((cleanDate - objSession) / 86400000);
			var _instance = daysAhead / session.frequency;

			session._instance = _instance;

			return session;
		});
	}

	updateCompletedHours(session) {
		session.student.hours = 0;
		var studentInfo = this.getStudentInfo(session._id);
		var diffDays = (this.calendarDate.getTime() - this.term.startDate) / (1000 * 3600 * 24);
		if(diffDays <= this.termDays && diffDays >= 0) {
			var index = diffDays / 7;
			for(var i = 0; i <= index; i++) {
				session.student.hours += studentInfo.weekList[i].duration;
			}
		}
		return session;
	}

	updateSessions() {
		var parsedDate = this.$filter('date')(this.calendarDate, 'dd/MM/yyyy');
		var cleanDate = this.$filter('reparseDate')(parsedDate);
		var todaysSessions = this.todaysSessions();
		todaysSessions.forEach(session => {
			if(!session || !session.student || !session.tutor) {
				return;
			}

			if(session.date === parsedDate) {
				session = this.updateCompletedHours(session);
				return this.addCalendar(session, 0);
			}

			var objSession = this.$filter('reparseDate')(session.date);

			var daysAhead = Math.round((cleanDate - objSession) / 86400000);

			var _instance = daysAhead / session.frequency; //returns supposed instance
			//remember that it's still zero-indexed here too

			session = this.updateCompletedHours(session);

			this.addCalendar(session, _instance);
		});

		this.addDropAndDrag();
	}

	updateCal() {
		this.visibleLessons = [];
		var diffDays = Math.abs((this.selectedDate.getTime() - this.calendarDate.getTime()) / (1000 * 3600 * 24));
		if(diffDays > 80 || !this.sessions) {
			this.selectedDate = this.calendarDate;
			this.setSearchTime(this.calendarDate);
			this.addTermSchedule();
			const cacheKey = this.location + '-' + JSON.stringify(this.monthLists);
			console.log('FETCHING:', cacheKey);
			if (this.locationCache[cacheKey]) {
				console.log('CACHE HIT:', cacheKey);
				this.sessions = this.locationCache[cacheKey];
				this.updateSessions();
				return;
			}
			this.$http.get('/api/lessons/time', {params: {monthLists: JSON.stringify(this.monthLists), location: this.location}}).then(response => {
				console.log('CACHE MISS:', cacheKey);
				this.locationCache[cacheKey] = response.data;
				if(!this.hasPreloadedLocations) {
					this.hasPreloadedLocations = true;
                    this.preloadOtherLocations();
				}
				this.sessions = response.data;
				this.updateSessions();
			}).catch(err => {
				console.error('Failed to load lessons:', err);
				this.loading = false;
			});
		} else {
			this.updateSessions();
		}
	}

	preloadOtherLocations() {
		console.log('Preloading other locations...');
	const locations = Object.keys(this.rooms);

	locations.forEach(location => {

		if(location === this.location) {
			console.log('Skipping location:', location);
			return;
		}

		const cacheKey = location + '-' + JSON.stringify(this.monthLists);

		if(this.locationCache[cacheKey]) {
			console.log('CACHE HIT IN PRELOAD:', cacheKey);
			return;
		}

		this.$http.get('/api/lessons/time', {
			params: {
				monthLists: JSON.stringify(this.monthLists),
				location
			}
		}).then(response => {
			console.log('Preload success:', location);
			this.locationCache[cacheKey] = response.data;

		}).catch(err => {
			console.error('Preload failed:', location, err);
		});

	});
}

	handleClick($event) {
		var _targ = $event.target.classList.contains('free-col') ? $event.target : $event.target.closest('.free-col');
		var _startTime = _targ.dataset.time;
		var _room = _targ.dataset.room;

		if(_targ.childElementCount === 0) {
			return this.addSessionModal(_startTime, _room);
		}

		//then there must be one or more items in the cell
		var closest = $event.target.classList.contains('session-cell') ? $event.target : $event.target.closest('.session-cell');
		var finalTarg = closest || _targ.firstChild;
		var _uid = finalTarg.dataset.id;
		var _instance = +finalTarg.dataset.instance;

		this.editSessionModal(_uid, _instance);
	}

	addDropAndDrag() {
		var drop = ev => {
			ev.preventDefault();
			var id = ev.dataTransfer.getData('text');
			var el = document.querySelector('[data-id="' + id + '"]');
			if(ev.target.appendChild(el)) {
				var instance = +el.dataset.instance;
				var time = +ev.target.dataset.time;
				var room = +ev.target.dataset.room;

				var session = this.sessions.find(session => id === session._id);
				if(!session) {
					return; //this likely will never be called though
				}
				session.overwriteStart = session.overwriteStart || {};
				session.overwriteStart[instance] = time;
				session.overwriteRoom = session.overwriteRoom || {};
				session.overwriteRoom[instance] = room;

				this.$http.put('/api/lessons/' + id, {
					overwriteRoom: session.overwriteRoom,
					overwriteStart: session.overwriteStart
				}).then(() => {
					console.log('Session updated:', id);
					this.invalidateLocationCache(this.location);
					this.clearCal();
				});
			}
		};

		var allowDrop = function(ev) {
			ev.preventDefault();
		};

		var dragEnter = function() {
			this.classList.add('drag-cell');
		};

		var dragLeave = function() {
			this.classList.remove('drag-cell');
		};

		var dragStart = function(ev) {
			//this is where the error is, id that is set here is incorrect
			ev.dataTransfer.setData('text', ev.target.dataset.id);
			this.classList.add('in-drag');
			this.closest('table').classList.add('in-drag');
		};

		var dragStop = function() {
			document.querySelectorAll('.in-drag').forEach(function(item) {
				item.classList.remove('in-drag');
			});
			document.querySelectorAll('.drag-cell').forEach(function(item) {
				item.classList.remove('drag-cell');
			});
		};

		document.querySelectorAll('.free-col').forEach(function(item) {
			item.ondrop = drop;
			item.ondragover = allowDrop;
			item.ondragenter = dragEnter;
			item.ondragleave = dragLeave;
		});

		document.querySelectorAll('.session-cell').forEach(function(item) {
			item.ondragstart = dragStart;
		});

		document.ondragend = dragStop;
		document.ondrop = dragStop;

		//Set scroll height properly
		var el = document.querySelector('.table-wrap');
		if(this.loading || this.changingDay) {
			el.scrollTop = 432;
		}

		this.changingDay = false;
		this.loading = false;
	}

reloadCal() {
    this.setSearchTime(this.calendarDate);
    this.addTermSchedule();

    const cacheKey = this.location + '-' + JSON.stringify(this.monthLists);

    this.$http.get('/api/lessons/time', {
        params: {
            monthLists: JSON.stringify(this.monthLists),
            location: this.location
        }
    }).then(response => {
        this.locationCache[cacheKey] = response.data;
        this.sessions = response.data;
        this.clearCal();
    });
}

	reloadStudents() {
		this.$http.get('/api/students').then(response => {
			this.students = response.data;
			this.invalidateLocationCache(this.location);
			this.reloadCal();
		});
	}

	addSessionModal(startTime, room) {
		this.$uibModal.open({
			template: require('./modal/add-session.html'),
			controller: 'SessionController',
	  		controllerAs: 'vm',
	  		windowClass: 'session-modal',
			resolve: {
				data: () => {
					return {
						startTime,
						room,
						location: this.location,
						date: this.calendarDate,
					};
				}
			}
		}).result.then(res => {
			if(res.reason == 'success') {
				this.showSuccess();
				this.invalidateLocationCache(this.location);
				this.sessions = null;
				this.clearCal();
			}
		});
	}

	editSessionModal(uid, instance) {
		var _data = this.sessions.find(item => item._id == uid);

		if(!_data) {
			return;
		}

		_data.aInstance = instance;

		this.$uibModal.open({
			template: require('./modal/edit-session.html'),
			controller: 'EditSessionController',
	  		controllerAs: 'vm',
	  		windowClass: 'session-modal',
			resolve: {
				data: () => {
					return _data;
				}
			}
		}).result.then(res => {
			if(res.reason == 'success') {
				this.showSuccess();
				const index = this.sessions.findIndex(s => s._id === res.data._id);
				this.sessions[index] = res.data;
				const cacheKey = this.location + '-' + JSON.stringify(this.monthLists);
				this.locationCache[cacheKey] = [...this.sessions];
				this.clearCal();
			}
		});
	}

	clearCal(delayUpdate) {
		console.log('clearing calendar');
		document.querySelectorAll('.session-cell').forEach(item => {
			item.parentNode.removeChild(item);
		});
		if(delayUpdate) {
			this.$timeout(() => {
				this.updateCal();
			}, 300);
		} else {
			this.updateCal();
		}
	}

	scrubAll() {
		//used by sandbox
		this.$http.get('/api/lessons/scrub-all').then(() => {
			this.reloadStudents();
		});
	}

	scrubDay() {
		//used by sandbox
		this.$http.post('/api/lessons/scrub-day', { list: this.visibleLessons }).then(() => {
			this.reloadStudents();
		});
	}

	addCalendar(session, instance) {
		//takes zero-based instances

		if(session.overwriteVisibility && session.overwriteVisibility[instance]) {
			return;
		}

		this.visibleLessons.push(session._id); //used by sandbox


		var identifier = 't' + session.startTime + 'r' + session.room;
		//identified applied to table cell,
		// 'a-' + identified to session div

		var specificNotes = (session.overwriteNotes && instance in session.overwriteNotes) ? session.overwriteNotes[instance] : null;
		//set colour

		var color = this.ColorFinder(session, instance);

		var _div = document.createElement('div');
		if(color.indexOf(' ') != -1) {
			var _temp = color.split(' ');
			color = _temp[1] + ' ' + _temp[0];
		}
		_div.className = 'session-cell';
		_div.id = 'a-' + identifier;
		_div.setAttribute('draggable', 'true');
		_div.setAttribute('data-id', session._id);
		_div.setAttribute('data-phone', session.student.clientPh);
		_div.setAttribute('data-email', session.student.clientEmail);
		_div.setAttribute('data-instance', instance);
		_div.setAttribute('data-tutor-phone', session.tutor ? session.tutor.phone : 'N/A');
		_div.setAttribute('data-tutor-email', session.tutor ? session.tutor.email : 'N/A');


		var _duration = this.HourFinder(session, instance);
		_div.style.height = `calc(${String(100 * (_duration / 30))}% - 4px)`;
		if(_duration < 60)
			_div.className += ' single-cell';

		var isChangeover = (session.overwriteChangeover && instance in session.overwriteChangeover) ? session.overwriteChangeover[instance] : session.changeover;
		if(isChangeover) {
			_div.className += ' changeover';
		}

		if(session.isChangeover && session.isChangeover[instance])
			_div.className += ' changeover';

		var isChangeoverStart = (session.overwriteChangeoverStart && instance in session.overwriteChangeoverStart) ? session.overwriteChangeoverStart[instance] : false;
		if(isChangeoverStart) {
			_div.className += ' changeover-start';
		}

		if(session.overwriteName && session.overwriteName[instance]) {
			_div.innerHTML = `<span class="student">${session.overwriteName[instance]}</span>`;
		} else {
			_div.innerHTML = `<span class="student">${session.student.firstName} ${session.student.lastName} (${session.student.hours})</span>`;
			// _div.innerHTML = `<span class="student">${session.student.firstName} ${session.student.lastName}</span>`;
		}

		_div.innerHTML += `<span class="tutor">${session.tutor.firstName} ${session.tutor.lastName}</span>`;

		var compiledNotes = '';
		if(session.globalNotes) {
			_div.innerHTML += `<br><span class="notes global-notes">${session.globalNotes}</span>`;
			compiledNotes += `Global Notes: \n${session.globalNotes}\n`;
		}
		if(specificNotes) {
			_div.innerHTML += `<br><span class="notes specific-notes">${specificNotes}</span>`;
			compiledNotes += `Specific Notes: \n${specificNotes}\n`;
		}
		if(specificNotes && (color.toLowerCase().includes('blue') || color.toLowerCase().includes('purple'))) {
			_div.className += ' has-notes';
		}

		//Add contact name
		if(session.student.clientFirstName || session.student.clientLastName) {
			compiledNotes += `Contact Name: ${session.student.clientFirstName} ${session.student.clientLastName}\n`;
		}

		//Add contact number
		if(session.student.clientPh) {
			compiledNotes += `Contact Number: ${session.student.clientPh}\n`;
		}
		//Add grade
		if(session.student.grade) {
		compiledNotes += `Student Year: ${session.student.grade}\n`;
		}
		//Add subjects
		if(session.student.subjects) {
		compiledNotes += `Subjects: ${session.student.subjects}\n`;
		}

		//Add tutor number
		if(session.tutor && session.tutor.phone) {
			compiledNotes += `Tutor Number: ${session.tutor.phone}\n`;
		}
		//Add title notes
		_div.setAttribute('title', compiledNotes);

		var _icons = '';
		if(session.overwriteVar1 && session.overwriteVar1[instance] === true)
			_icons += `<i class="fa fa-${this.icons.first} norm-icon" aria-hidden="true"></i>`;
		if(session.overwriteVar2 && session.overwriteVar2[instance] === true)
			_icons += `<i class="fa fa-${this.icons.second} norm-icon" aria-hidden="true"></i>`;
		if(session.student.var3)
			_icons += `<i class="fa fa-${this.icons.third} norm-icon" aria-hidden="true"></i>`;
		if(session.student.var4)
			_icons += `<i class="fa fa-${this.icons.fourth} norm-icon" aria-hidden="true"></i>`;
		if(session.overwriteVar5 && session.overwriteVar5[instance] === true)
			_icons += `<i class="fa fa-${this.icons.fifth} norm-icon" aria-hidden="true"></i>`;
		if(session.overwriteVar6 && session.overwriteVar6[instance] === true)
			_icons += `<i class="fa fa-${this.icons.sixth} norm-icon" aria-hidden="true"></i>`;
		if(session.overwriteVar7 && session.overwriteVar7[instance] === true)
			_icons += `<i class="fa fa-${this.icons._tempUnknown} norm-icon" aria-hidden="true"></i>`;
		if(session.overwriteVar12 && session.overwriteVar12[instance] === true)
			_icons += '<i class="fa fa-' + this.icons.xero + '" aria-hidden="true"></i>';
		if(session.student.var8)
			_icons += '<i class="fa fa-' + this.icons._permUnknown + ' norm-icon" aria-hidden="true"></i>';
		if(session.student.var9)
			_icons += '<i class="fa fa-' + this.icons._perm2Unknown + ' norm-icon" aria-hidden="true"></i>';
		if(session.student.var7)
			_icons += '<i class="fa fa-' + this.icons._perm3Unknown + '" aria-hidden="true"></i>';
		if(session.student.var10)
			_icons += '<i class="fa fa-' + this.icons._perm4Unknown + '" aria-hidden="true"></i>';
		if(session.student.var11)
			_icons += '<i class="fa fa-' + this.icons._perm5Unknown + '" aria-hidden="true"></i>';
		if(session.student.grade === 12)
			_icons += '<i class="fa fa-' + this.icons.year12 + ' grade-12" aria-hidden="true"></i>';
		if(specificNotes)
			_icons += '<i class="fa fa-' + this.icons._note + ' norm-icon" aria-hidden="true"></i>';
		if(session.student.price === '$65')
			_icons += '<i class="fa"><strong>65</strong></i>';
		if(session.student.price === '$70')
			_icons += '<i class="fa"><strong>70</strong></i>';
		if(session.student.price === '$75')
			_icons += '<i class="fa"><strong>75</strong></i>';
		if(session.student.price === '$80')
			_icons += '<i class="fa"><strong>80</strong></i>';
		if(session.student.price === '$90')
			_icons += '<i class="fa"><strong>90</strong></i>';
		if(_icons)
			_div.innerHTML += '<div class="icon-row">' + _icons + '</div>';

		_div.innerHTML += '<div class="a-bg ' + 'aa' + color + '"></div>';
		var _start = this.StartFinder(session, instance);
		var _room = (session.overwriteRoom && instance in session.overwriteRoom) ? session.overwriteRoom[instance] : session.room;
		var _targ = document.getElementById('t' + _start + 'r' + _room);
		_targ && _targ.insertBefore(_div, null);
	}

	isCurrentDay(index) {
		return this.calendarDate.getDay() === index;
	}

	setDayOfWeek(index) {
		this.changingDay = true;
		const newIndex = (index + 1) % 7;

		var targetDate = this.calendarDate.getDate() + (newIndex - this.calendarDate.getDay());
		if(this.calendarDate.getDay() === 0) { //if currently sunday
			targetDate -= 7;
		} else if(newIndex === 0) { //if moving to sunday
			targetDate += 7;
		}

		this.calendarDate = new Date(this.calendarDate.setDate(targetDate));
		this.clearCal();
	}

	createArray(length) {
		return Array.apply(null, Array(length)).map(function(x, i) { return i; });
	}

	dateRange(startDate, endDate) {
		var start = startDate.split('/');
		var end = endDate.split('/');
		var startYear = parseInt(start[2]);
		var endYear = parseInt(end[2]);
		var dates = [];

		for(var i = startYear; i <= endYear; i++) {
		  var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
		  var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
		  for(var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
			var month = j + 1;
			var displayMonth = month < 10 ? '0' + month : month;
			dates.push([i, displayMonth, '01'].join('/'));
		  }
		}
		return dates;
	}

	// a and b are javascript Date objects
	dateDiffInDays(a, b) {
		const _MS_PER_DAY = 1000 * 60 * 60 * 24;
		// Discard the time and time-zone information.
		const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
		const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
		return Math.floor((utc2 - utc1) / _MS_PER_DAY);
	}

	lockChangeDays(days) {
		var currentDate = new Date();
		var diffDays = days === null ? this.dateDiffInDays(currentDate, this.calendarDate) : days;
		if(days === null) {
			this.switchDays = 0;
		}
		if(this.username === 'paddington' || this.username === 'cannonhill') {
			this.switchDays += diffDays;
			if(this.switchDays > 10) {
				this.switchDays = 10;
				currentDate.setDate(currentDate.getDate() + 10);
			} else if(this.switchDays < -10) {
				this.switchDays = -10;
				currentDate.setDate(currentDate.getDate() - 10);
			} else {
				days = days === null ? 0 : days;
				currentDate = new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth(), this.calendarDate.getDate() + days);
			}
			this.calendarDate = currentDate;
		} else {
			if(days !== null) {
				this.calendarDate = new Date(this.calendarDate.getFullYear(), this.calendarDate.getMonth(), this.calendarDate.getDate() + days);
			}
		}
	}

	addDays(days) {
		//calendarDate is re-int bc watcher won't update
		//with regular setTime()
		this.changingDay = true;
		// set user accounts to access current, prev and next week sessions
		this.lockChangeDays(days);
		this.clearCal();
	}

	changeLocation(location) {
		this.changingDay = true;
		this.location = location;
		this.sessions = null; // force re-fetch with new location filter
		this.clearCal(true);
	}
}



// WEBPACK FOOTER //
// ./client/app/calendar/calendar.controller.js